export const COMPONENT_TEXT = {
  NO_SEARCH: {
    TH: 'ไม่พบข้อมูล',
    EN: 'No data.'
  }
}
